import CookiePolicy from '@/components/Organisms/PolicyTabs/CookiePolicy'
import PrivacyPolicyForCandidates from '@/components/Organisms/PolicyTabs/PrivacyPolicyForCandidates'
import { MainTemplate } from '@/components/shared/templates'
import DashboardTemplateV2 from '@/components/shared/templates/DashboardTemplateV2'
import { isLoggedIn } from '@/utils/lib'
import { Tabs } from 'antd'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import clsx from 'clsx'
import TermsConditionsForCandidates from '@/components/Organisms/PolicyTabs/TermsConditionsForCandidates'
import TermsAndConditionsForEmployers from '@/components/Organisms/PolicyTabs/TermsAndConditionsForEmployers'
import PrivacyPolicyForEmployers from '@/components/Organisms/PolicyTabs/PrivacyPolicyForEmployers'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const Policies: NextPage = () => {
  const router = useRouter()
  const [activeTab, setActiveTab] = useState('privacy-policy-for-candidates')

  useEffect(() => {
    const path = router.asPath
    if (path !== '/policies') {
      const tabKey = path.split('/').pop()
      if (tabKey) {
        setActiveTab(tabKey)
      }
    }
  }, [router.asPath])

  const handleTabChange = (key: string) => {
    setActiveTab(key)
    if (key === 'privacy-policy-for-candidates') {
      router.push('/policies')
    } else {
      router.push(`/policies/${key}`)
    }
  }

  const template = ({ children }: { children: React.ReactNode }) => {
    return isLoggedIn() ? (
      <DashboardTemplateV2>{children}</DashboardTemplateV2>
    ) : (
      <MainTemplate>{children}</MainTemplate>
    )
  }

  return template({
    children: (
      <div
        className={clsx(
          'flex justify-center items-center py-4 px-2',
          isLoggedIn() ? 'bg-white' : 'bg-qureosBgGray'
        )}
      >
        <div className="container xl:max-w-[1280px] mx-auto px-2 md:px-6">
          <Tabs activeKey={activeTab} onChange={handleTabChange}>
            <Tabs.TabPane
              tab="Privacy Policy for Candidates"
              key="privacy-policy-for-candidates"
            >
              <PrivacyPolicyForCandidates />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab="Terms & Conditions for Candidates"
              key="terms-conditions-for-candidates"
            >
              <TermsConditionsForCandidates />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab="Privacy Policy for Companies"
              key="privacy-policy-for-companies"
            >
              <PrivacyPolicyForEmployers />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab="Terms & Conditions for Companies"
              key="terms-conditions-for-companies"
            >
              <TermsAndConditionsForEmployers />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Cookie Policy" key="cookie-policy">
              <CookiePolicy />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
    )
  })
}
export async function getServerSideProps(context) {
  const { locale } = context
  return {
    props: {
      ...(await serverSideTranslations(locale))
    }
  }
}

export default Policies
